import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Typography, Breadcrumbs, Box, Alert } from '@mui/material';
import { useAuth } from '@contexts/AuthContext';
import Layout from '@components/Layout';
import PackTable from '@components/pack/PackTable';
function MyPacksPage() {
    const { t } = useTranslation();
    const { type } = useParams();
    const { getCurrentCustomerId } = useAuth();
    const customerId = getCurrentCustomerId();

    return (
        <Layout>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Breadcrumbs aria-label="breadcrumb">
                    <Typography>{t("{{type}} credits", { type: t(`credit.${type}`) })}</Typography>
                </Breadcrumbs>
            </Box>

            <PackTable customerId={customerId} type={type} />

            <Alert severity="info" sx={{ mt: 2 }}>
                {t('In order to add {{type}} credits, please contact your account manager.', { type: t(`credit.${type}`) })}
            </Alert>

        </Layout>
    );
}

export default MyPacksPage;